import quantityImg from '@/assets/images/plans-icons/quantity.png'
import moreConnectionsImg from '@/assets/images/plans-icons/moreConnections.png'
import batchExportImg from '@/assets/images/plans-icons/batchExport.png'
import shopifyTagsMetafieldsImg from '@/assets/images/plans-icons/shopifyTagsMetafields.png'
import customFieldsImg from '@/assets/images/plans-icons/customFields.png'
import customTemplatesImg from '@/assets/images/plans-icons/customTemplates.png'
import customViewsImg from '@/assets/images/plans-icons/customViews.png'
import customInventoryImg from '@/assets/images/plans-icons/customInventory.png'
import biggzyRipsImg from '@/assets/3d-assets/testimonial/biggzy.jpeg'
import minnygraphs99Img from '@/assets/3d-assets/testimonial/minny.jpeg'
import viawaveCollectiblesImg from '@/assets/3d-assets/testimonial/viawave.jpeg'
import fineCardsImg from '@/assets/3d-assets/testimonial/finecards.jpeg'
import gametimecards247Img from '@/assets/3d-assets/testimonial/gametime.jpeg'

export const QUICK_UPGRADE_MODAL_TYPES = {
  QUANTITY: 'add-quantity',
  MORE_CONNECTIONS: 'import',
  BATCH_EXPORT: 'full-export',
  TAGS_AND_METAFIELDS: 'shopify-metafields',
  CUSTOM_FIELDS: 'custom-fields',
  CUSTOM_TEMPLATES: 'custom-templates',
  CUSTOM_VIEWS: 'custom-views',
  CUSTOM_INVENTORY: 'custom_inventory',
  UPGRADE_PLAN: 'upgrade_plan',
  FULL_EXPORT: 'full-export',
  INVENTORY_EXPORT: 'inventory-export'
}

export const FEATURE_MIN_PLAN = {
  [QUICK_UPGRADE_MODAL_TYPES.QUANTITY]: 2,
  [QUICK_UPGRADE_MODAL_TYPES.MORE_CONNECTIONS]: 2,
  [QUICK_UPGRADE_MODAL_TYPES.BATCH_EXPORT]: 2,
  [QUICK_UPGRADE_MODAL_TYPES.TAGS_AND_METAFIELDS]: 4,
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_FIELDS]: 2,
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_TEMPLATES]: 2,
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_VIEWS]: 2,
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_INVENTORY]: 2,
  [QUICK_UPGRADE_MODAL_TYPES.FULL_EXPORT]: 4,
  [QUICK_UPGRADE_MODAL_TYPES.UPGRADE_PLAN]: 1,
  [QUICK_UPGRADE_MODAL_TYPES.INVENTORY_EXPORT]: 4,
}

export const SHORT_PLAN_FEATURES_DESC = {
  1: 'Also includes 500 AI credits/mo, 2 marketplace connections, AI Card ID, market pricing, import, bulk editing',
  2: 'Also includes 1,100 AI credits/mo, 3 marketplace connections, quantity feature, batch/inventory export, inventory views',
  4: 'Also includes 5,000 AI credits/mo, 4 marketplace connections, custom inventory export, and more',
}

export const UPGRADE_MODALS = {
  [QUICK_UPGRADE_MODAL_TYPES.QUANTITY]: {
    title: (plan) => `Upgrade to ${plan} to unlock Quantity`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: quantityImg,
    type: QUICK_UPGRADE_MODAL_TYPES.QUANTITY,

  },
  [QUICK_UPGRADE_MODAL_TYPES.MORE_CONNECTIONS]: {
    title: (plan) => `Upgrade to ${plan} to unlock more Marketplace Connections`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: moreConnectionsImg,
    type: QUICK_UPGRADE_MODAL_TYPES.MORE_CONNECTIONS,
  },
  [QUICK_UPGRADE_MODAL_TYPES.BATCH_EXPORT]: {
    title: (plan) => `Upgrade to ${plan} to unlock Full Batch Export`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: batchExportImg,
    type: QUICK_UPGRADE_MODAL_TYPES.BATCH_EXPORT,
  },
  [QUICK_UPGRADE_MODAL_TYPES.TAGS_AND_METAFIELDS]: {
    title: (plan) => `Upgrade to ${plan} to unlock Shopify Tag & Metafield Mapping`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: shopifyTagsMetafieldsImg,
    type: QUICK_UPGRADE_MODAL_TYPES.TAGS_AND_METAFIELDS,
  },
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_FIELDS]: {
    title: (plan) => `Upgrade to ${plan} Plan to use Custom Fields`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: customFieldsImg,
    type: QUICK_UPGRADE_MODAL_TYPES.CUSTOM_FIELDS,
  },
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_TEMPLATES]: {
    title: (plan) => `Upgrade to ${plan} to unlock Custom Titles & Descriptions`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: customTemplatesImg,
    type: QUICK_UPGRADE_MODAL_TYPES.CUSTOM_TEMPLATES,
  },
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_VIEWS]: {
    title: (plan) => `Upgrade to ${plan} Plan to use Custom Views`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: customViewsImg,
    type: QUICK_UPGRADE_MODAL_TYPES.CUSTOM_VIEWS,
  },
  [QUICK_UPGRADE_MODAL_TYPES.CUSTOM_INVENTORY]: {
    title: (plan) => `Upgrade to ${plan} to unlock Custom Inventory Export`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: customInventoryImg,
    type: QUICK_UPGRADE_MODAL_TYPES.CUSTOM_INVENTORY,
  },
  [QUICK_UPGRADE_MODAL_TYPES.FULL_EXPORT]: {
    title: (plan) => `Upgrade to ${plan} to unlock Custom Inventory Export`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: customInventoryImg,
    type: QUICK_UPGRADE_MODAL_TYPES.FULL_EXPORT,
  },
  [QUICK_UPGRADE_MODAL_TYPES.UPGRADE_PLAN]: {
    title: (plan, label) => `${label} to ${plan}`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: null,
    type: QUICK_UPGRADE_MODAL_TYPES.UPGRADE_PLAN,
  },
  [QUICK_UPGRADE_MODAL_TYPES.INVENTORY_EXPORT]: {
    title: (plan) => `Upgrade to ${plan} to unlock Inventory Export`,
    description: (planInfo) => SHORT_PLAN_FEATURES_DESC[planInfo.id],
    image: customInventoryImg,
    type: QUICK_UPGRADE_MODAL_TYPES.INVENTORY_EXPORT,
  },
}

export const CARD_BRAND_ICONS = {
  visa: 'logos:visa',
  mastercard: 'logos:mastercard',
  amex: 'logos:amex',
  discover: 'logos:discover',
  diners: 'logos:diners-club',
  jcb: 'logos:jcb',
  unionpay: 'logos:unionpay',
}

export const PLANS_PERIODS = {
  selected: 'monthly',
  selectedIndex: 1,
  options: [
    { value: 'annual', label: 'Annual' },
    { value: 'monthly', label: 'Monthly' },
  ]
}

export const PLANS_OPTIONS = [
  {
    id: 1,
    value: 'prospect',
    label: 'Prospect',
    brief: 'For dealers just getting started',
    features: {
      title: '',
      options: [
        { value: 'credits', label: '500 Monthly AI credits' },
        { value: 'listing', label: 'List to CollX + 1 Marketplace' },
        { value: 'uploading', label: 'Add from Scanner, Phone or Cert' },
        { value: 'market_pricing', label: 'AI Card ID & Market Pricing' },
        { value: 'import', label: 'Import from eBay, CollX' },
        { value: 'inventory', label: 'Inventory Management' },
      ]
    },
    price: {
      monthly: 9,
      annual: 8,
      annual_base: 108,
      annual_save: 11,
      annual_final: 96,
      badge: {
        type: 'trial',
        value: '7-Day Free Trial',
      },
    },
    action_text: 'Get Prospect Free for 7 Days',
  },

  {
    id: 2,
    value: 'majors',
    label: 'Majors',
    brief: 'For dealers and stores who need more operational efficiency',
    features: {
      title: 'All the features of Prospect plan:',
      options: [
        { value: 'credits', label: '1,100 monthly AI credits' },
        { value: 'listing', label: 'List to CollX + 2 Marketplaces' },
        { value: 'quantity', label: 'Add Quantity to Inventory' },
        { value: 'templates', label: 'Custom Title & Description Templates' },
        { value: 'views', label: 'Create Custom Fields & Inventory Views' },
      ]
    },
    price: {
      monthly: 19,
      annual: 16,
      annual_base: 228,
      annual_save: 17,
      annual_final: 192,
      badge: {
        type: 'save',
        value: 'Save $17 per year',
      },
    },
    action_text: 'Continue with Majors',
  },

  {
    id: 4,
    value: 'all_star',
    label: 'All-Star',
    brief: 'For growing shops, dealers, and enterprises that need to scale up',
    features: {
      title: 'All the features of Majors plan:',
      options: [
        { value: 'credits', label: '5,000 monthly AI credits' },
        { value: 'listing', label: 'List to CollX + 3 Marketplaces' },
        { value: 'tag', label: 'Shopify Metafield and Tag Mapping' },
        { value: 'inventory_export', label: 'Custom Inventory Export (Coming Soon)' },
      ]
    },
    price: {
      monthly: 59,
      annual: 49,
      annual_base: 708,
      annual_save: 17,
      annual_final: 588,
      badge: {
        type: 'save',
        value: 'Save $17 per year',
      },
    },
    action_text: 'Continue with All-Star',
  }
]

export const BEST_VALUE_PLAN = 'majors'

export const PLANS_FAQ = [
  {
    key: 'key_1',
    question: 'What happens after my free trial ends?',
    answer: 'After your 7-day trial, your paid plan begins automatically unless you cancel first.'
  },
  {
    key: 'key_2',
    question: 'Can I change or cancel my plan later?',
    answer: 'Yes — you can upgrade, downgrade, or cancel anytime.'
  },
  {
    key: 'key_3',
    question: 'Which plan should I choose?',
    answer: 'Choose the plan that fits your current volume. You can always upgrade later or add credits if you need more.'
  },
  {
    key: 'key_4',
    question: 'What marketplaces does Card Dealer Pro work with?',
    answer: 'Card Dealer Pro connects directly to eBay, CollX, Whatnot and Shopify. You can also export a csv of your cards to import to any system.'
  },
  {
    key: 'key_5',
    question: 'How quickly can I get started?',
    answer: 'Most dealers can get started the same day by creating an account and starting to scan or import inventory.'
  },
]

export const PLAN_CAROUSEL_VIDEOS = [
  {
    src: 'https://storage.googleapis.com/cdp-assets/snaptik_7598386877837626638_v3.mp4',
    title: 'Video 1',
    user: {
      image: biggzyRipsImg,
      name: 'Biggzy Rips',
      username: '@biggzyrips',
      link: 'https://www.tiktok.com/@biggzyrips'
    }
  },
  {
    src: 'https://storage.googleapis.com/cdp-assets/snaptik_7602380175690583326_v3.mp4',
    title: 'Video 1',
    user: {
      image: minnygraphs99Img,
      name: 'Minnygraphs99',
      username: '@minnygraphs99',
      link: 'https://www.tiktok.com/@minnygraphs99'
    }
  },
  {
    src: 'https://storage.googleapis.com/cdp-assets/snaptik_7616359825747807519_v3.mp4',
    title: 'Video 1',
    user: {
      image: viawaveCollectiblesImg,
      name: 'ViaWave Collectibles',
      username: '@viawave.collectib',
      link: 'https://www.tiktok.com/@viawave.collectib'
    }
  },
  {
    src: 'https://storage.googleapis.com/cdp-assets/snaptik_7561909566376643870_v3.mp4',
    title: 'Video 1',
    user: {
      image: fineCardsImg,
      name: 'Fine Cards',
      username: '@finecards3',
      link: 'https://www.tiktok.com/@finecards3'
    }
  },
  {
    src: 'https://storage.googleapis.com/cdp-assets/snaptik_7596049391048346893_v3.mp4',
    title: 'Video 1',
    user: {
      image: gametimecards247Img,
      name: 'Gametimecards247',
      username: '@finecards3',
      link: 'https://www.tiktok.com/@gametimecards247'
    }
  },
]